import { createAsyncThunk } from '@reduxjs/toolkit';

import callApi from '../../../service/callApi';
import { enqueueSnackbar } from '../../notifier/notifierActions';
import sendRequest from '../../../service/sendRequest';

export const GET_AGENTS = 'id8Settings/GET_AGENTS';
export const GET_AGENT = 'id8Settings/GET_AGENT';
export const ADD_SYSTEM_AGENT = 'id8Settings/ADD_SYSTEM_AGENT';
export const ADD_CUSTOM_AGENT = 'id8Settings/ADD_CUSTOM_AGENT';
export const EDIT_SYSTEM_AGENT = 'id8Settings/EDIT_SYSTEM_AGENT';
export const EDIT_CUSTOM_AGENT = 'id8Settings/EDIT_CUSTOM_AGENT';
export const DELETE_AGENT = 'id8Settings/DELETE_AGENT';

export const getAgents = createAsyncThunk(GET_AGENTS, async (_, { getState }) => {
  const { page, size, search } = getState().id8Settings.tableSettings;

  const response = await sendRequest(() =>
    callApi.post(`/api/id8/agent/search?page=${page + 1}&size=${size}&query=${search}`),
  );

  return { content: response.data.content, total: response.data.totalElements };
});

export const getAgent = createAsyncThunk(GET_AGENT, async (id) => {
  const response = await sendRequest(() => callApi.get(`/api/id8/agent/${id}`));

  return response.data;
});

export const addSystemAgent = createAsyncThunk(
  ADD_SYSTEM_AGENT,
  async ({ name, instructions }, { dispatch, rejectWithValue }) => {
    await sendRequest(
      () =>
        callApi.put(`/api/id8/agent/register/system`, {
          name,
          instructions,
        }),
      {
        onError: () => {
          dispatch(
            enqueueSnackbar({
              message: 'couldntCreateAgent',
              options: { variant: 'error' },
            }),
          );
          return rejectWithValue(null);
        },
      },
    );

    dispatch(
      enqueueSnackbar({
        message: 'agentHasBeenAddedSuccessfully',
        options: {
          variant: 'success',
          messageParams: {
            agentName: name,
          },
        },
      }),
    );
  },
);

export const editSystemAgent = createAsyncThunk(
  EDIT_SYSTEM_AGENT,
  async ({ id, values }, { dispatch, rejectWithValue }) => {
    const { name, instructions } = values;

    await sendRequest(
      () =>
        callApi.patch(`/api/id8/agent/edit/system?id=${id}`, {
          name,
          instructions,
        }),
      {
        onError: () => {
          dispatch(
            enqueueSnackbar({
              message: 'couldntChangeAgent',
              options: { variant: 'error' },
            }),
          );
          return rejectWithValue(null);
        },
      },
    );

    dispatch(
      enqueueSnackbar({
        message: 'agentHasBeenChangedSuccessfully',
        options: {
          variant: 'success',
          messageParams: {
            agentName: name,
          },
        },
      }),
    );
  },
);

export const editCustomAgent = createAsyncThunk(
  EDIT_CUSTOM_AGENT,
  async ({ id, instructions }, { dispatch, rejectWithValue }) => {
    await sendRequest(
      () =>
        callApi.patch(`/api/id8/agent/edit/custom?id=${id}`, {
          instructions,
        }),
      {
        onError: () => {
          dispatch(
            enqueueSnackbar({
              message: 'couldntChangeAgent',
              options: { variant: 'error' },
            }),
          );
          return rejectWithValue(null);
        },
      },
    );
  },
);

export const addCustomAgent = createAsyncThunk(
  ADD_CUSTOM_AGENT,
  async (instructions, { dispatch, rejectWithValue }) => {
    const response = await sendRequest(() => callApi.put(`/api/id8/agent/register/custom`, { instructions }), {
      onError: () => {
        dispatch(enqueueSnackbar({ message: 'couldntCreateAgent', options: { variant: 'error' } }));
        return rejectWithValue(null);
      },
    });

    return response.data;
  },
);

export const deleteAgent = createAsyncThunk(DELETE_AGENT, async ({ id }, { dispatch, rejectWithValue }) => {
  await sendRequest(() => callApi.delete(`/api/id8/agent?id=${id}`), {
    onError: () => {
      dispatch(
        enqueueSnackbar({
          message: 'couldntDeleteAgent',
          options: { variant: 'error' },
        }),
      );
      return rejectWithValue(null);
    },
  });

  dispatch(
    enqueueSnackbar({
      message: 'agentHasBeenRemovedSuccessfully',
      options: {
        variant: 'success',
      },
    }),
  );

  dispatch(getAgents());
});
